// extracted by mini-css-extract-plugin
export default {"row":"FeelingLucky_row__c6TU5","name":"FeelingLucky_name__tiPnF"};